import { render, staticRenderFns } from "./BlockAllCustomers.vue?vue&type=template&id=12e68843&scoped=true&"
import script from "./BlockAllCustomers.vue?vue&type=script&lang=js&"
export * from "./BlockAllCustomers.vue?vue&type=script&lang=js&"
import style0 from "./BlockAllCustomers.vue?vue&type=style&index=0&id=12e68843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e68843",
  null
  
)

export default component.exports